import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.utkarsita.com/api/v1',
    // prepareHeaders: async (headers, { getState }) => {
    //   headers.set('Content-Type', 'application/json');
    //   return headers;
    // },
    credentials: 'include',
  }),
  tagTypes: ['Payment'],
  endpoints: (builder) => ({
    
    createPayment: builder.mutation({
        query: (body) => ({
          url: '/payment',
          method: 'POST',
          body,
        }),
      }),
    retryPayment: builder.mutation({
        query: (body) => ({
          url: '/payment/retry',
          method: 'POST',
          body,
        }),
      }),
      
    //   getCartItems: builder.query({
    //     query: () => ({
    //       url: '/cart/cart-items',
    //       method: 'GET',
    //     }), 
    //     providesTags: ['Cart'],
    //   }),

    //   getGuestCartItems: builder.query({
    //     query: () => ({
    //       url: '/cart/guest/cart-items',
    //       method: 'GET',
    //     }), 
    //     providesTags: ['Cart'],
    //   }),

    //   getAddresses: builder.query({
    //     query: () => ({
    //       url: '/address/all',
    //       method: 'GET',
    //     }), 
    //     providesTags: ['address'],
    //   }),
  }),
});

export const {
 useCreatePaymentMutation,
 useRetryPaymentMutation
} = paymentApi;
